<template>
  <div class="GlobalFormDemo">
    <GlobalForm ref="form" :needBtnLoading="true" :init-data="initData" :form-item-list="formItemList" :inline="true" round
      @handleConfirm="handleConfirm" confirmBtnName="查询">
        <el-form-item class="el_from" label="回收商名称" slot="operationSelect2" label-width="90px">
        <el-select
          v-model="merchantId"
          placeholder="请选择回收商"
          filterable
          clearable
          clear="clearMerchant"
        >
          <el-option
            v-for="item in merchantSelectList"
            :key="item.merchantId"
            :label="item.merchantName"
            :value="item.merchantId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="门店商名称" slot="operationSelect3" label-width="90px">
        <el-select
          v-model="companyId"
          placeholder="请选择门店商"
          filterable
          clearable
        >
          <el-option
            v-for="item in companySelectList"
            :key="item.companyId"
            :label="item.companyName"
            :value="item.companyId"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="订单状态" slot="orderStatus" style="margin:0" label-width="70px">
        <el-select
          v-model="orderStatus"
          placeholder="请选择订单状态"
          clearable
        >
          <el-option
            v-for="item in orderStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item class="el_from" label="订单号" slot="orderNo1" style="margin:0" label-width="60px">
        <el-input v-model="orderNo" clearable placeholder="请输入订单号"></el-input>
      </el-form-item>
        <el-form-item class="el_from" label="费用类型" slot="priceType" style="margin:0" label-width="90px">
        <el-select v-model="priceType" placeholder="请选择" filterable clearable style="width: 200px;" @change="handleModeOpt">
          <el-option v-for="item in priceTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="账单类型" slot="orderNo" style="margin:0" label-width="70px">
        <el-select v-model="opt" placeholder="请选择账单类型查询" filterable clearable @change="handleChangeOpt">
          <el-option v-for="item in optList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="子类型" slot="serTypeList" style="margin:0;" label-width="70px" >
        <el-select v-model="serType" placeholder="请选择" filterable clearable @change="handleChangeSerType">
          <el-option v-for="item in serTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-button icon="el-icon-download" slot="AddSlot" type="success" :loading="exportLoading" @click="exportBill" size="small" style="float: none;">导出账单</el-button>
    </GlobalForm>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
export default {
  name: "Form",
  props: {
    accountType: {
      require: true,
      type: String
    },
    info: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      isCustomUser: "",
      initData: {
          entryTime: [
            moment().day(moment().day()).format("YYYY-MM-DD 00:00:00"),
            moment().format("YYYY-MM-DD 23:59:59"),
          ],
        },
      companyId: "",
      opt: "",
      InquirySelectList: [],
      storeList: [],
      serTypeList: [],
      serType: "",
      isHasCompany: false,
      day31: 30 * 24 * 3600 * 1000,
      pickerMinDate: null,
      formItemList: [
            {slotName:"orderNo1"},
            {slotName:"operationSelect2"},
            {slotName:"operationSelect3"},
            {slotName:"orderStatus"},
            {
                key: "entryTime",
                type: "pickerOptions",
                labelName: "账单时间",
                clearable: true,
                lableWidth: '50',
                placeholder: "请选择时间",
                valueFormat: "timestamp",
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                    if (minDate && this.pickerMinDate) {
                        this.pickerMinDate = null;
                    } else if (minDate) {
                        this.pickerMinDate = minDate.getTime();
                    }
                    },
                    disabledDate: (time) => {
                    if (this.pickerMinDate) {
                        return (
                        time.getTime() > this.pickerMinDate + this.day31 ||
                        time.getTime() < this.pickerMinDate - this.day31
                        );
                    }
                    return false;
                    },
                },
            },
        {slotName:"priceType"},
        { slotName: 'orderNo' },
        { slotName: 'opt' },
        { slotName: 'serTypeList' },
   
      ],
      optList: [
        {
          value: '00',
          label: '全部',
        },
        {
          value: '01',
          label: '入账',
        },
        {
          value: '02',
          label: '出账',
        },
      ],
      transferData: {
        amountPrice: "",
      },
      NumMoney: "",
      butLoading: false,
      dialogVisible: false,
      merchantId:"",
      merchantSelectList:[],
      companySelectList:[],
      orderNo:"",
      priceTypeList:[],
      priceType:"",
      orderStatus:"",
      orderStatusList:[],
      exportLoading:false,
    };
  },
  created() {

    _api.getMatchChannelSerTypeList().then(res=>{
            if (res.code === 1) {
        this.serTypeList = res.data
      }
    })
    this.handleConfirm(this.initData);
    this.getMatchMerchantList()
    this.getMatchCompanyList()
    _api.orderStatusList().then((res) => {
        let arr = [];
        for (const item of res.data) {
          arr.push({
            value: item.key,
            label: item.value,
          });
        }
        this.orderStatusList = arr;
      });
          _api.getMatchChannelAccountNoList().then(res=>{
      if (res.code === 1) {
        this.priceTypeList = res.data
      }
    })
  },

  watch: {
  },
  methods: {
    handleConfirm(data,cd) {
      console.log("提交了form", data,this.entryTime);
      let SeachParams = {};
      if (data) {
        SeachParams = {
          opt: this.opt || "",
          serType: this.serType || "",
          startTime: data.entryTime ? moment(data.entryTime[0]).format("x") : "",
          endTime: data.entryTime ? moment(data.entryTime[1]).format("x") : "",
          pageNum: 1,
          pageSize: 10,
          merchantId:this.merchantId||"",
          orderNo:this.orderNo||"",
          accountNo:this.priceType||"",
          companyId:this.companyId||"",
        };
      }
      SeachParams.disuseLoding= () => {
          if(typeof cd ==='function'){
             cd();
          }
        },
      this.formData = SeachParams
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
        exportBill() {
      console.log(this.formData);
      let params = {
        merchantId: this.formData.merchantId,
        opt: this.formData.opt,
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        serType: this.formData.serType,
        orderNo:this.formData.orderNo,
        ccountNo:this.formData.priceType,
        companyId:this.formData.companyId||"",
      };
      this.exportLoading = true;
      _api.getMatchChannelExcel(params).then(res => {
        console.log(res)
        const content = res;
        const blob = new Blob([content]);

        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "分润账单.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
          this.exportLoading = false;
        });
    },
    handleChangeSerType(val) {
      this.serType = val
    },
    handleChangeOpt(val) {
      this.opt = val
      this.serType = ""
      let params={
        opt:this.opt
      }
      if(this.priceType){
        params.accountNo=this.priceType
      }
      _api.getMatchChannelSerTypeList(params).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data
        }
      })
    },
        handleModeOpt(val){
      console.log(this.opt,99999)
      this.priceType = val
      this.serType = ""
      let params={
        accountNo:this.priceType
      }
      if(this.opt){
        params.opt=this.opt
      }
      _api.getMatchChannelSerTypeList(params).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data
        }
      })
    },
   // 获取回收商家
    getMatchMerchantList() {
      _api.matchMerchantList({pageNum: 1,pageSize:99999}).then(res => {
        if (res.code === 1) {
          this.merchantSelectList = res.data;
        }
      });
    },
    // 获取门店商家
    getMatchCompanyList(id) {
      console.log(999999999999)
      _api.companyList({pageNum: 1,pageSize:99999}).then(res => {
        if (res.code === 1) {
          this.companySelectList = res.data;
        }
      });
    },

  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .balance-form {
    /deep/.el-form-item__label {
      line-height: 32px;
    }

    /deep/.el-form-item__content {
      line-height: 32px;
    }
  }
}
/deep/.el-form--inline .el-form-item--small{
  float: none !important;
}
</style>
